import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { SitemateTaskTypes, UserTypes } from '@site-mate/dashpivot-shared-library';

import { TemplateLinksComponent } from 'app/apps/templates-link/template-links/template-links.component';
import { AuthGuard } from 'app/auth/auth-guard.service';
import { AppHierarchy } from 'app/shared/model/app-hierarchy.enum';
import {} from 'app/shared/service/feature-flag-guard.service';
import { ReleaseUpdateGuard } from 'app/shared/service/release-update-guard.service';

import { UserCompanyComponent } from './users-dashpivot/user-company/user-company.component';
import { UserProjectComponent } from './users-dashpivot/user-project/user-project.component';
import { UserTeamComponent } from './users-dashpivot/user-team/user-team.component';
import { FormUsersComponent } from './users-sitemate/form-users/form-users.component';
import { IdentityCardsComponent } from './users-sitemate/identity-cards/identity-cards.component';
import { UsersComponent } from './users.component';

const routes: Routes = [
  {
    path: 'companies/:companyId',
    component: UsersComponent,
    data: { hierarchy: AppHierarchy.Organisation },
    canActivateChild: [AuthGuard, ReleaseUpdateGuard],
    children: [
      { path: '', redirectTo: 'dashpivot/contributors', pathMatch: 'full' },
      {
        path: 'dashpivot/contributors',
        pathMatch: 'prefix',
        component: UserCompanyComponent,
        data: { userType: UserTypes.Contributor },
      },
      {
        path: 'dashpivot/visitors',
        pathMatch: 'prefix',
        component: UserCompanyComponent,
        data: { userType: UserTypes.Visitor },
      },
      {
        path: 'sitemate/id-cards',
        pathMatch: 'prefix',
        component: IdentityCardsComponent,
        data: { hasInfoPanel: true },
      },
      {
        path: 'sitemate/forms',
        pathMatch: 'prefix',
        component: FormUsersComponent,
      },
    ],
  },
  {
    path: 'projects/:projectId',
    component: UsersComponent,
    data: { hierarchy: AppHierarchy.Project },
    canActivateChild: [AuthGuard, ReleaseUpdateGuard],
    children: [
      { path: '', redirectTo: 'dashpivot/contributors', pathMatch: 'full' },
      {
        path: 'dashpivot/contributors',
        pathMatch: 'prefix',
        component: UserProjectComponent,
        data: { userType: UserTypes.Contributor },
      },
      {
        path: 'dashpivot/visitors',
        pathMatch: 'prefix',
        component: UserProjectComponent,
        data: { userType: UserTypes.Visitor },
      },
      {
        path: 'sitemate/id-cards',
        pathMatch: 'prefix',
        component: IdentityCardsComponent,
        data: { hasInfoPanel: true },
      },
      {
        path: 'sitemate/forms',
        pathMatch: 'prefix',
        component: FormUsersComponent,
      },
    ],
  },
  {
    path: 'teams/:teamId',
    component: UsersComponent,
    data: { hierarchy: AppHierarchy.Team },
    canActivateChild: [AuthGuard, ReleaseUpdateGuard],
    children: [
      { path: '', redirectTo: 'dashpivot/contributors', pathMatch: 'full' },
      {
        path: 'dashpivot/contributors',
        pathMatch: 'prefix',
        component: UserTeamComponent,
        data: { userType: UserTypes.Contributor },
      },
      {
        path: 'dashpivot/visitors',
        pathMatch: 'prefix',
        component: UserTeamComponent,
        data: { userType: UserTypes.Visitor },
      },
      {
        path: 'sitemate/id-cards',
        pathMatch: 'prefix',
        component: IdentityCardsComponent,
        data: { hasInfoPanel: true },
      },
      {
        path: 'sitemate/forms',
        pathMatch: 'prefix',
        component: FormUsersComponent,
        children: [
          {
            path: 'links',
            component: TemplateLinksComponent,
            data: { taskType: SitemateTaskTypes.FormRecurring },
          },
        ],
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class UsersRoutingModule {}
